/* eslint-disable no-unused-vars */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isAuth, accessToken, currentUser } from '../../helpers/auth';

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuth() && accessToken() && currentUser() ? (
        <Redirect
          to={{
            pathname: '/app/profile',
            state: { from: props.location }
          }}
        />
      ) :
        (
          <Component {...props} />
        )
    }
  />
);

PublicRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  location: PropTypes.object
};

export default PublicRoute;
